
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Header */}
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-600 rounded-full text-sm font-medium mb-4">
              隐私保护
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-6">隐私政策</h1>
            <p className="text-xl text-gray-600">
              我们重视您的隐私，承诺按照法律要求保护您的个人信息
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 lg:p-12">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-8">
                尊敬的用户：
              </p>
              <p className="text-gray-700 leading-relaxed mb-8">
                欢迎访问我们的网站。此隐私政策（以下简称"政策"）旨在说明我们如何收集、使用、储存和保护您在使用我们网站时提供的个人信息。我们重视您的隐私，并承诺按照法律要求和行业标准来处理您的个人信息。
              </p>

              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                    信息收集
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    为了提供更好的服务和产品，我们会收集您在使用我们网站时提供的一些个人信息。这些信息可能包括但不限于您的姓名、电子邮件地址、电话号码、邮寄地址等。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                    信息使用
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    我们收集的这些信息将用于改善我们的服务，为您提供更个性化的体验，以及用于必要的管理和处理目的。例如，我们需要您的姓名和电子邮件地址以便在您忘记密码时重置密码，或者需要您的邮寄地址以便向您发送您购买的产品。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                    信息储存
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    我们将在安全的环境中储存您的个人信息，并采取适当的措施以保护您的信息免受未经授权的访问、使用或披露。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                    信息保护
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    我们承诺不会向第三方出售、出租或交换您的个人信息，除非在遵守法律要求或与第三方进行必要的业务合作时。我们会对任何违反隐私政策的员工或合作伙伴采取适当的行动。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                    第三方链接
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    我们的网站可能包含指向第三方网站的链接。我们不对这些网站的数据收集和使用行为负责，因此请在使用这些网站时自行查看其隐私政策。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">6</span>
                    政策更新
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    我们可能会更新此政策。如有任何修改，我们将在网站上公布新的隐私政策。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">7</span>
                    联系我们
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    如果您对我们的隐私政策有任何疑问或需要帮助，请通过我们网站上提供的联系方式与我们联系。
                  </p>
                </div>
              </div>

              <div className="mt-12 p-6 bg-emerald-50 rounded-xl border border-emerald-200">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-shield-check-line text-emerald-600 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-emerald-800 mb-2">我们的承诺</h3>
                    <p className="text-emerald-700 text-sm leading-relaxed">
                      感谢您对我们的支持，我们将尽最大努力保护您的隐私。
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 text-center">
                <p className="text-gray-500 text-sm">
                  最后更新时间：{new Date().toLocaleDateString('zh-CN')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
